// src/utils/helpers/copyToClipboard.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import appService from 'services/appService';

// *******************************************************************************
// COPY TEXTO TO CLIPBOARD
// *******************************************************************************
export const copyToClipboard = (text, successMessage) => {
  // Use modern clipboard API if available
  if (navigator?.clipboard?.writeText) {
    navigator.clipboard
      .writeText(String(text))
      .then(() => successMessage && appService.message({ flag: 'success', text: successMessage }))
      .catch(() => fallbackCopy(text, successMessage));
    return;
  }
  // Fallback for older browsers
  fallbackCopy(text, successMessage);
};

function fallbackCopy(text, successMessage) {
  try {
    const el = document.createElement('textarea');
    el.value = String(text);
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    successMessage && appService.message({ flag: 'success', message: successMessage });
  } catch (e) {
    // Silent fail to avoid UX noise
  }
}
